import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  namespaced: true,
  state: {
    // 路由
    activePath: '',
  },
  getters: {},
  mutations: {
    // 提交动态属性
    setActivePath(state, activePath) {
      state.activePath = activePath
    },
  },
  actions: {},
  modules: {},
})
